// Re-export types from switch-core (single source of truth)
export type {
  Member,
  MemberRole,
  MembershipStatus,
  MembershipStatusType,
} from "@/core_bridge/module_api";

// Re-export validation functions
export { validateMember, parseMember } from "@/core_bridge/module_api";

import { Member } from "@/core_bridge/module_api";

// Schema compatibility layer - provides .parse() method for backward compatibility
export const memberSchema = {
  parse: (data: unknown): Member => data as Member,
  safeParse: (data: unknown) => {
    try {
      return { success: true as const, data: data as Member };
    } catch (e) {
      return { success: false as const, error: e };
    }
  },
};

export const membersSchema = {
  parse: (data: unknown): Member[] => data as Member[],
};

// Type alias for backward compatibility
export type Members = Member[];
